// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Slider/Slider.global.scss
// module id = FOdx
// module chunks = 0